import { render, staticRenderFns } from "./CarteirasAba.vue?vue&type=template&id=3b6321ec&scoped=true"
import script from "./CarteirasAba.vue?vue&type=script&lang=js"
export * from "./CarteirasAba.vue?vue&type=script&lang=js"
import style0 from "./cashback.css?vue&type=style&index=0&id=3b6321ec&prod&scoped=true&lang=css&external"
import style1 from "./CarteirasAba.vue?vue&type=style&index=1&id=3b6321ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6321ec",
  null
  
)

export default component.exports